var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEllipse206CourseDot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 7,
    viewBox: "0 0 7 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    fill: "#F5F5F5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Admin LMS"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1017 -1502C-1017 -1503.1 -1016.1 -1504 -1015 -1504H10848C10849.1 -1504 10850 -1503.1 10850 -1502V2924C10850 2925.1 10849.1 2926 10848 2926H-1015C-1016.1 2926 -1017 2925.1 -1017 2924V-1502Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1015 -1503H10848V-1505H-1015V-1503ZM10849 -1502V2924H10851V-1502H10849ZM10848 2925H-1015V2927H10848V2925ZM-1016 2924V-1502H-1018V2924H-1016ZM-1015 2925C-1015.55 2925 -1016 2924.55 -1016 2924H-1018C-1018 2925.66 -1016.66 2927 -1015 2927V2925ZM10849 2924C10849 2924.55 10848.6 2925 10848 2925V2927C10849.7 2927 10851 2925.66 10851 2924H10849ZM10848 -1503C10848.6 -1503 10849 -1502.55 10849 -1502H10851C10851 -1503.66 10849.7 -1505 10848 -1505V-1503ZM-1015 -1505C-1016.66 -1505 -1018 -1503.66 -1018 -1502H-1016C-1016 -1502.55 -1015.55 -1503 -1015 -1503V-1505Z",
    fill: "black",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Course",
    clipPath: "url(#clip0_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1280,
    height: 832,
    transform: "translate(-550.5 -427)",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 27552"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Recently Uploaded Courses"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 27195",
    filter: "url(#filter0_d_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -67.8333,
    y: -29,
    width: 378.667,
    height: 408,
    rx: 8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 27196",
    clipPath: "url(#clip1_0_1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Recent Uploads"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-1_0_1",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-51.8333 -13H288.167V88H-51.8333V-13Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-51.8333 -13H288.167V88H-51.8333V-13Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.167 87H-51.8333V89H288.167V87Z",
    fill: "#E9ECEB",
    mask: "url(#path-4-inside-1_0_1)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 27542"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 27556"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 27557"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 206",
    cx: 3.16666,
    cy: 3.5,
    r: 3,
    fill: "#6D6D6D"
  })))))))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_0_1",
    x: -87.8333,
    y: -45,
    width: 418.667,
    height: 448,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.158125 0 0 0 0 0.203077 0 0 0 0 0.2875 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1280,
    height: 832,
    fill: "white",
    transform: "translate(-550.5 -427)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 340,
    height: 372,
    fill: "white",
    transform: "translate(-51.8333 -13)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipse206CourseDot);
export default __webpack_public_path__ + "static/media/Ellipse 206Course-Dot.a740a45f21eb074c4f2e4c6c18e8510a.svg";
export { ForwardRef as ReactComponent };